// React Third-Party Libraries
import { Form, message } from "antd";
import { useDispatch } from "react-redux";
import { useEffect } from 'react';

// Constants Library

// Components Library
import DrawerFormEmployee from "../DrawerFormEmployee";
import { Options } from "../../../../../../components";

// Services Library

// Redux Actions
import * as REDUX_ACTION from "../../../../../../services/redux/actions";

const { bankList } = Options;

const DrawerEditEmployee = (props) => {
  const { isOpen, setIsOpen, data, company, user } = props;
  
  const dispatch = useDispatch();
  const [messageApi, contextHolder] = message.useMessage();
  const [form] = Form.useForm(); 

  useEffect(() => {
    if (isOpen) {
      const contactWithoutPrefix = data.contact.replace('+60', '');
      const companyName = company[data.coid]?.name || '';
      form.setFieldsValue({ 
        ...data,
        contact: contactWithoutPrefix,
        coName: companyName,
      });
      
    }
  }, [isOpen]);

  const handleSave = () => {
    form
      .validateFields()
      .then((record) => {
        
        const selectedBank = bankList.find((bank) => bank.value.name === record.bank_name);
        const bank_code = selectedBank ? selectedBank.value.bank_code : '';
        
        const formattedIc = record.ic.replace(/-/g, '');
        const formattedBankHolderIc = record.bank_holderIc.replace(/-/g, '');

        const contactString = String(record.contact);
        let contactConvert;
        if (contactString.startsWith("+62")) {
          contactConvert = contactString;
        } else {
          contactConvert = `+60${contactString}`;
        }

        const formData = {
          uid: data.uid,
          updatedBy: user.memid,
          items: {
            ...data, 
            ...record,
            contact : contactConvert,
            bank_code: bank_code,
            ic: formattedIc,
            bank_holderIc: formattedBankHolderIc,
          },
        }

        messageApi.open({
          type: "loading",
          content: "Updating...",
          duration: 0,
        });

        dispatch(REDUX_ACTION.v1_employee.update_employee_request(formData, user.uroleid, () => {
          messageApi.destroy();
        }));
      })
      .catch((err) => {
        message.error("fill the form");
      });
  };

  return (
    <>
      {contextHolder}
      <DrawerFormEmployee
        form={form}
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        type="edit"
        handleSave={handleSave}
      />
    </>
  );
};

export default DrawerEditEmployee;
